/**
 * ProgramTimeline - Phase bar with slider at the bottom of the network area.
 * Shows program phases and a time range picker.
 */

import React, { useState } from 'react';
import { Box, Typography, Slider, IconButton } from '@mui/material';
import {
  PlayArrow as PlayIcon,
  SkipPrevious as SkipPrevIcon,
  SkipNext as SkipNextIcon,
} from '@mui/icons-material';
import { TIMELINE_PHASES } from '../../constants/dashboardConfig';
import TimeRangePicker from './TimeRangePicker';

 
 
 
 
 
 
 
 
// eslint-disable-next-line max-lines-per-function
function ProgramTimeline() {
  const [activePhase, setActivePhase] = useState(0);
  const [sliderValue, setSliderValue] = useState(50);
  const [showDatePicker, setShowDatePicker] = useState(false);

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        zIndex: 50,
      }}
    >
      {/* Phase Bar */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          height: 40,
          borderRadius: 1,
          overflow: 'hidden',
          bgcolor: 'grey.100',
          position: 'relative',
        }}
      >
        {/* Progress overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: `${sliderValue}%`,
            background: 'linear-gradient(90deg, rgba(35, 163, 143, 0.12), rgba(35, 163, 143, 0.04))',
            borderRight: '3px solid #23A38F',
            transition: 'width 0.3s ease',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />

        {TIMELINE_PHASES.map((phase, i) => (
          <Box
            key={phase.id}
            onClick={() => setActivePhase(i)}
            sx={{
              flex: phase.flex,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRight: i < TIMELINE_PHASES.length - 1 ? 1 : 0,
              borderColor: 'grey.200',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 2,
              bgcolor: activePhase === i ? 'rgba(35, 163, 143, 0.08)' : 'transparent',
              color: activePhase === i ? '#23A38F' : 'text.secondary',
              transition: 'all 0.3s',
              '&:hover': {
                bgcolor: 'rgba(35, 163, 143, 0.08)',
              },
            }}
          >
            <Typography
              variant="caption"
              sx={{ fontWeight: 600, fontSize: '0.7rem' }}
            >
              {phase.label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Playback Controls */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <SkipPrevIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <PlayIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <SkipNextIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      {/* Time Slider */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: 140 }}>
        <Slider
          value={sliderValue}
          onChange={(e, v) => setSliderValue(v)}
          size="small"
          sx={{
            color: '#23A38F',
            '& .MuiSlider-thumb': { width: 14, height: 14 },
          }}
        />
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: '#23A38F', minWidth: 55, fontSize: '0.65rem' }}
        >
          {sliderValue < 33 ? 'Early' : sliderValue < 66 ? 'Mid' : 'Current'}
        </Typography>
      </Box>

      {/* Date Range Toggle */}
      <TimeRangePicker
        open={showDatePicker}
        onToggle={() => setShowDatePicker(!showDatePicker)}
      />
    </Box>
  );
}

export default ProgramTimeline;
